import ServiceBase from '@/Services/ServiceBase';

export default class AssetGroupService extends ServiceBase {
    getAssetGroup(assetGroupId) {
        return this.request('get', `/assetgroup/${assetGroupId}`);
    }

    updateAssetGroup(assetGroupId, assetGroup) {
        return this.request('put', `/assetgroup/${assetGroupId}`, assetGroup);
    }

    createImageAsset(assetGroupId, { horizontalFilename = null, verticalFilename = null, squareFilename = null, shortVerticalFilename = null }) {
        return this.request('post', `/assetgroup/${assetGroupId}/imageAsset`, {
            horizontalFilename,
            verticalFilename,
            squareFilename,
            shortVerticalFilename,
        });
    }

    createTextAsset(assetGroupId, text, type) {
        return this.request('post', `/assetgroup/${assetGroupId}/textAsset`, {
            text,
            type,
        });
    }

    activateAssetGroup(assetGroupId) {
        return this.request('post', `/assetgroup/${assetGroupId}/activate`);
    }

    pauseAssetGroup(assetGroupId) {
        return this.request('put', `/assetgroup/${assetGroupId}/pause`);
    }

    unpauseAssetGroup(assetGroupId) {
        return this.request('put', `/assetgroup/${assetGroupId}/unpause`);
    }

    deleteAssetGroup(assetGroupId) {
        return this.request('delete', `/assetgroup/${assetGroupId}`);
    }

    getAdPreview(assetObject) {
        return this.request('post', '/assetgroup/adPreview?contentType=html', assetObject);
    }

    regenerateTextSuggestions(assetGroupId, textAssetType) {
        return this.request('post', `assetgroup/${assetGroupId}/regenerateContentSuggestions `, {
            textAssetType,
        });
    }

    feedbackTextSuggestions(assetGroupId, textAssetType, feedback) {
        return this.request('post', `assetgroup/${assetGroupId}/feedbackTextSuggestions`, {
            textAssetType,
            feedback,
        });
    }

    publishAssetGroup(assetGroupId, suggestedAssetGroup) {
        return this.request('post', `/assetgroup/${assetGroupId}/publish`, suggestedAssetGroup);
    }

    rejectAssets(assetGroupId, suggestionIds) {
        return this.request('put', `/assetgroup/${assetGroupId}/rejectContentSuggestions`, {
            suggestionIds,
        });
    }

    createVideoAsset(assetGroupId, { verticalFilename = null, squareFilename = null }) {
        return this.request('post', `/assetgroup/${assetGroupId}/videoAsset`, {
            verticalFilename,
            squareFilename,
        });
    }

    rejectCreativeSuggestion(assetGroupId, suggestionId, reason, feedback) {
        return this.request('post', `assetgroup/${assetGroupId}/rejectCreativeSuggestion`, {
            suggestionId,
            reason,
            feedback,
        });
    }

    getAssetGroupScoring(assetGroupId) {
        return this.request('get', `/assetgroup/${assetGroupId}/rating`);
    }
}